import { response as res } from  '@vkontakte/vkui-connect-mock';

export const setMockData = () => {
    res.VKWebAppGetUserInfo.data = {
        type: 'VKWebAppGetUserInfoResult',
        data: {
            id: 4267535,
            photo_100: 'https://pp.userapi.com/c841034/v841034569/3b8c1/pt3sOw_qhfg.jpg',
            photo_200: 'https://pp.userapi.com/c841034/v841034569/3b8c1/pt3sOw_qhfg.jpg',
            first_name: 'Денис',
            last_name: 'Кот',
            sex: 0,
            city: {
                id: 1,
                title: 'Белгород',
            },
            country: {
                id: 1,
                title: 'UK'
            },
            timezone: 0
        },
    };
};


// WEBPACK FOOTER //
// ./src/js/services/mock.js